"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DirectPanel_1 = tslib_1.__importDefault(require("../panels/DirectPanel"));
/**
 * @deprecated use {@link DialogManager} and {@link DialogContent} instead
 */
class DialogWrapper {
    constructor(remoteDialog) {
        this.remoteDialog = remoteDialog;
        this.panel = new DirectPanel_1.default();
    }
    getElementById(id) {
        return this.remoteDialog.getElementById(id);
    }
    getElementByVarName(varName) {
        return this.remoteDialog.getElementByVarName(varName);
    }
    addAndReplace(widget, varName) {
        let toReplace = this.getElementByVarName(varName);
        if (toReplace == null) {
            throw new Error(`No such variable: "${varName}"`);
        }
        this.panel.addAndReplaceElement(widget, toReplace);
    }
    addAndReplaceElement(widget, id) {
        let toReplace = this.getElementById(id);
        if (toReplace == null) {
            throw new Error("No element with id: \"" + id + "\"");
        }
        this.panel.addAndReplaceElement(widget, toReplace);
    }
    addWrapper(widget) {
        this.panel.addWrapper(widget);
    }
    show() {
        this.remoteDialog.show();
    }
    showWithOffset(offsetFromTop) {
        this.remoteDialog.showWithOffset(offsetFromTop);
    }
    showWithOptions(options) {
        this.remoteDialog.showWithOptions(options);
    }
    hide() {
        this.remoteDialog.hide();
    }
}
exports.default = DialogWrapper;
//# sourceMappingURL=DialogWrapper.js.map